function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { actions as ppcActions } from '../../reducers/ppc.reducer';
import PageBackButton from '../common/page/PageBackButton.react';
import Card from '../common/card/Card.react';
import CardHeader from '../common/card/CardHeader.react';
import CardBody from '../common/card/CardBody.react';
import Label from '../common/form/Label.react';
import Input from '../common/form/Input.react';
import Textarea from '../common/form/Textarea.react';
import Button from '../common/Button.react';
var Testimonial = function Testimonial() {
  var navigate = useNavigate();
  var _useParams = useParams(),
    app = _useParams.app,
    testimonialID = _useParams.testimonialID;
  var dispatch = useDispatch();
  var _useSelector = useSelector(function (s) {
      return s.ppc;
    }),
    testimonials = _useSelector.testimonials;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  useEffect(function () {
    dispatch({
      type: ppcActions.testimonials,
      payload: {
        formData: {
          app: app,
          testimonialID: testimonialID
        }
      }
    });
  }, [app, testimonialID]);
  useEffect(function () {
    setState(testimonials[testimonialID] || {});
  }, [testimonials, testimonialID]);
  var name = state.name,
    company = state.company,
    email = state.email,
    testimonial = state.testimonial,
    archived = state.archived;
  var isValid = function isValid() {
    return !archived;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "page__content"
  }, app && /*#__PURE__*/React.createElement(PageBackButton, null), /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Testimonial"
  }), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(Label, {
    label: "Name"
  }), /*#__PURE__*/React.createElement(Input, {
    value: name,
    onChange: function onChange(e) {
      return setState(_objectSpread(_objectSpread({}, state), {}, {
        name: e.target.value
      }));
    }
  }), /*#__PURE__*/React.createElement(Label, {
    label: "Company",
    required: true
  }), /*#__PURE__*/React.createElement(Input, {
    value: company,
    onChange: function onChange(e) {
      return setState(_objectSpread(_objectSpread({}, state), {}, {
        company: e.target.value
      }));
    }
  }), /*#__PURE__*/React.createElement(Label, {
    label: "Email",
    required: true
  }), /*#__PURE__*/React.createElement(Input, {
    value: email,
    onChange: function onChange(e) {
      return setState(_objectSpread(_objectSpread({}, state), {}, {
        email: e.target.value
      }));
    }
  }), /*#__PURE__*/React.createElement(Label, {
    label: "Testimonial",
    required: true
  }), /*#__PURE__*/React.createElement(Textarea, {
    value: testimonial,
    onChange: function onChange(e) {
      return setState(_objectSpread(_objectSpread({}, state), {}, {
        testimonial: e.target.value
      }));
    },
    style: {
      height: 120
    }
  }), !archived && /*#__PURE__*/React.createElement("div", {
    className: "a__btns"
  }, /*#__PURE__*/React.createElement(Button, {
    label: "Update",
    disabled: !isValid(),
    apiID: "update-testimonial",
    onClick: function onClick() {
      dispatch({
        type: ppcActions.testimonials,
        payload: {
          formData: {
            testimonialID: testimonialID,
            name: name,
            company: company,
            email: email,
            testimonial: testimonial,
            apiID: 'update-testimonial'
          },
          method: 'put',
          route: 'update'
        }
      });
    }
  }), /*#__PURE__*/React.createElement(Button, {
    label: "Delete",
    apiID: "delete-testimonial",
    type: "delete",
    requireConfirmation: true,
    onClick: function onClick() {
      dispatch({
        type: ppcActions.testimonials,
        payload: {
          formData: {
            testimonialID: testimonialID,
            apiID: 'delete-testimonial'
          },
          method: 'post',
          route: 'delete'
        }
      });
      navigate('/' + app + '/testimonials');
    }
  }))))));
};
export default Testimonial;